// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const DashboardSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.4 2H3.6C2.71635 2 2 2.71635 2 3.6V12.4C2 13.2837 2.71635 14 3.6 14H12.4C13.2837 14 14 13.2837 14 12.4V3.6C14 2.71635 13.2837 2 12.4 2Z" stroke={color} stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.3335 9.00001L11.3335 6.66667M9.61921 10.1667C9.61921 10.811 9.10755 11.3333 8.47635 11.3333C7.84515 11.3333 7.3335 10.811 7.3335 10.1667C7.3335 9.52232 7.84515 9.00001 8.47635 9.00001C9.10755 9.00001 9.61921 9.52232 9.61921 10.1667Z" stroke={color} strokeLinecap="round" />
        <path d="M4.6665 8C4.6665 6.15906 6.25838 4.66667 8.22206 4.66667C8.8697 4.66667 9.47687 4.82899 9.99984 5.11261" stroke={color} strokeLinecap="round" />
    </svg>

);
